import React from "react";
import InnerLink from './InnerLink';
import { reduxForm, Field } from "redux-form";
import { FormattedDate, FormattedTime } from "react-intl";
import { required } from "../utility";
import { MaterialTextField } from "./MaterialInput";
import IconButton from '@material-ui/core/IconButton';
import Grid from '@material-ui/core/Grid';
import SubmitButton from './SubmitButton';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import DeleteIcon from '@material-ui/icons/Delete';
import Typography from '@material-ui/core/Typography';

const commentForm = ({comments = [], userPermissions = [], car, onAddComment, onDeleteComment, handleSubmit}) => (
    <Paper className="common-paper" style={{ marginTop: 20, marginBottom: 20 }}>
        <Grid container justify="center" spacing={16}>
            <Grid item className="common-column">
                <form className="common-form" onSubmit={handleSubmit(data => onAddComment(car, data))} >
                     <Field component={MaterialTextField}
                            rows={5}
                            multiline
                            validate={required}
                            name="text"
                            label="Комментарий" />
                     <SubmitButton label="Добавить" />
                </form>
            </Grid>
            <Grid item className="ultrawide-column">
                { comments.length ?
                    <Table padding="checkbox">
                        <TableHead>
                            <TableRow>
                                <TableCell>Дата</TableCell>
                                <TableCell>Автор</TableCell>
                                <TableCell>Комментарий</TableCell>
                                {userPermissions.includes("client-comment-delete") && <TableCell>&nbsp;</TableCell>}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            { comments.map(({_id, date, text, author: {id, fullname = ""} = {}}, i) =>
                                <TableRow key={i}>
                                    <TableCell>
                                        <FormattedDate value={date}
                                                       day="numeric"
                                                       month="numeric"
                                                       year="numeric" />
                                        <br />
                                        <FormattedTime value={date}
                                                       hour="numeric"
                                                       minute="numeric"
                                                       second="numeric" />
                                    </TableCell>
                                    <TableCell>
                                        <InnerLink target="_blank" href={`/user/${id}`} label={fullname.split(" ")[0]} />
                                    </TableCell>
                                    <TableCell>{text}</TableCell>
                                    {userPermissions.includes("client-comment-delete") &&
                                        <TableCell>
                                            <IconButton onClick={() => onDeleteComment(car, _id)}>
                                                <DeleteIcon />
                                            </IconButton>
                                        </TableCell>
                                    }
                                </TableRow>
                            )}
                        </TableBody>
                    </Table> : <Typography>Заметок нет</Typography> }
            </Grid>
        </Grid>
    </Paper>
);

const CommentForm = reduxForm({form: "comment-form" })(commentForm);

export default CommentForm;



// WEBPACK FOOTER //
// ./src/components/CommentForm.js